import script from "./UserComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserComponent.vue?vue&type=script&lang=ts&setup=true"

import "./UserComponent.vue?vue&type=style&index=0&id=4a27dd37&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a27dd37"]])

export default __exports__